module.exports = __webpack_public_path__ + "static/img/label-04.3e5308b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/dhl/label-04.png
// module id = bEir
// module chunks = 150